const CONCEPT_ASSET_VERSION = process.env.NEXT_PUBLIC_CONCEPT_ASSET_VERSION ?? 'unversioned';

export function versionedConceptAssetUrl(path: string): string {
  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}v=${encodeURIComponent(CONCEPT_ASSET_VERSION)}`;
}

export function smallConceptIconUrl(path: string): string {
  return path.replace('/concept-icons/', '/concept-icons-small/');
}
